import { ErrorMessage, ValidMessage } from "@atlaskit/form";
import React from "react";
export var isRepoValid = function (repoName) {
    return !repoName || RegExp(/git@bitbucket\.org:.*\/.*\.git/).test(repoName);
};
export var RepoValidationMessage = function (_a) {
    var repoName = _a.repoName;
    var isValid = isRepoValid(repoName);
    if (isValid) {
        return React.createElement(ValidMessage, null, "Valid Repo");
    }
    return React.createElement(ErrorMessage, null, "Invalid Repo");
};
